import React, { FC } from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

import colors from '~/constants/colors';
import ApplicationNavStep from './ApplicationNavStep';
import { useGetWizardNavSteps } from '~/controllers/navigation';
import { useDirection } from '~/hooks/i18nHooks';

type Props = {
  stageKey: string;
  rootPath: string;
  rootStep: string;
};

const WizardNavigation: FC<Props> = ({ stageKey, rootPath, rootStep }: Props) => {
  const navStepsQuery = useGetWizardNavSteps(stageKey, rootPath, rootStep);
  const dir = useDirection();

  return (
    <Container className="WizardNavigation" dir={dir}>
      {navStepsQuery.isLoading ? (
        <Spin />
      ) : (
        navStepsQuery.data.map((item, index, arr) => {
          const isLast = index === arr.length - 1;
          return (
            <div key={item.stepKey} className="WizardNavigation-StepContainer">
              <ApplicationNavStep index={index + 1} {...item} stageKey={stageKey} />
              {!isLast && <div className="WizardNavigation-Divider" />}
            </div>
          );
        })
      )}
    </Container>
  );
};

const Container = styled.div`
  position: sticky;
  top: 66px;
  display: flex;
  margin-left: 60px;
  flex-direction: column;
  .WizardNavigation-StepContainer {
    display: flex;
    flex-direction: column;
    .WizardNavigation-Divider {
      display: flex;
      border-left: 1px solid ${colors.borderColorBase};
      height: 8px;
      width: 1px;
      margin: 8px;
    }
  }
`;

export default WizardNavigation;
